import React, { FC } from 'react';

import ChooseSubscriptionModal, {
  ReasonType,
} from '~/modules/settings/components/modals/ChooseSubscriptionModal';
import PolyllmRestoreModal from '~/projects/polyllm-chat/components/SubscriptionModal/PolyllmRestoreModal';

export type SubscriptionModalProps = {
  type: ReasonType;
  onClose: () => void;
};

/**
 * PolyLLM-specific implementation of the subscription modal slot
 * injected via `ProjectBehaviorStrategy.SubscriptionModal`.
 *
 * For `NO_ACTIVE_SUBSCRIPTION` (the "Subscription is canceled / expired /
 * not active" backend error family) we render a ChatWithAI-styled restore
 * modal so users with a hard-cancelled subscription get a restore CTA
 * instead of the legacy purchase flow. Other reasons keep delegating to
 * the shared `ChooseSubscriptionModal` for now.
 */
const PolyllmSubscriptionModal: FC<SubscriptionModalProps> = ({
  type,
  onClose,
}) => {
  if (type === ReasonType.NO_ACTIVE_SUBSCRIPTION) {
    return <PolyllmRestoreModal onClose={onClose} />;
  }

  return <ChooseSubscriptionModal type={type} onClose={onClose} />;
};

export default PolyllmSubscriptionModal;
